import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ProfileDto } from '@shared/types';

const KEY = ['profile', 'me'] as const;

export interface ProfileInput {
  phone?: string | null;
  signatureCs?: string | null;
  signatureEn?: string | null;
  signaturePl?: string | null;
  signatureVi?: string | null;
  avatarUrl?: string | null;
  emailDigestEnabled?: boolean;
  emailDigestTime?: string | null;
}

export function useProfile() {
  const qc = useQueryClient();

  const list = useQuery({
    queryKey: KEY,
    queryFn: async () => (await api.get<{ data: ProfileDto }>('/profile')).data,
  });

  const update = useMutation({
    mutationFn: (input: ProfileInput) =>
      api.patch<{ data: ProfileDto }>('/profile', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });

  return { profile: list.data, isLoading: list.isLoading, error: list.error, update };
}
